import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const biolinkAnalytics = createAsyncThunk('biolinkAnalytics/biolinkAnalytics', async (data) => {
    const token = localStorage.getItem('token')
    try {
        const res = await axios({
            method: 'get',
            url: process.env.REACT_APP_API_URL + `biolink_analytic`,
            params: {
                user_name: data?.user_name,
                user_id: token ? localStorage.getItem("id") : '',
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

